import { Link } from 'react-router-dom'
import { comics, featuredComic, editorPickComic } from '@/mocks/comics'
import ScrollReveal from '@/components/base/ScrollReveal'

export default function HotRecommendSection() {
  const hotList = comics.filter(c => c.isHot).slice(0, 2)
  const risingComics = comics.filter(c => c.isRising).slice(0, 2)

  return (
    <section className="py-16 md:py-24 bg-background-50" aria-labelledby="hot-recommend-title">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">

        <ScrollReveal direction="up" className="flex flex-col md:flex-row md:items-end justify-between mb-10 md:mb-14 gap-4">
          <div>
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 rounded-full text-xs font-medium mb-3">
              编辑精选
            </span>
            <h2 id="hot-recommend-title" className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              本周热门推荐
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md">
            根据阅读量、评分和读者反馈综合筛选，每周为你精选最值得一看的韩漫作品
          </p>
        </ScrollReveal>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 md:gap-6">

          {/* 编辑强推大卡 */}
          <ScrollReveal direction="up" delay={0} duration={650} className="lg:col-span-5">
            <Link
              to={`/article/${editorPickComic.id}`}
              className="group relative block bg-foreground-900 rounded-2xl overflow-hidden cursor-pointer h-full min-h-[400px] hover:-translate-y-1 hover:shadow-[0_12px_40px_-10px_oklch(var(--foreground-900)/0.3)] transition-all duration-500 ease-out"
            >
              <img
                src={editorPickComic.cover}
                alt={editorPickComic.title}
                className="absolute inset-0 w-full h-full object-cover object-top opacity-60 group-hover:opacity-75 group-hover:scale-105 transition-all duration-700 ease-out"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <span className="inline-block px-3 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-full mb-3">
                  编辑强推
                </span>
                <h3 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-2">
                  {editorPickComic.title}
                </h3>
                <p className="text-sm text-background-200/80 leading-relaxed line-clamp-2 mb-3 max-w-md">
                  {editorPickComic.description}
                </p>
                <div className="flex items-center gap-4 text-xs text-background-300">
                  <span>{editorPickComic.author}</span>
                  <span className="w-1 h-1 rounded-full bg-background-500"></span>
                  <span>{editorPickComic.status}</span>
                  <span className="w-1 h-1 rounded-full bg-background-500"></span>
                  <span>{editorPickComic.views}阅读</span>
                </div>
              </div>
            </Link>
          </ScrollReveal>

          {/* 飙升卡片 */}
          <ScrollReveal direction="up" delay={120} duration={600} className="lg:col-span-3">
            <Link
              to={`/article/${featuredComic.id}`}
              className="group block bg-background-50 rounded-2xl border border-background-200/70 hover:border-primary-300 hover:-translate-y-1 hover:shadow-[0_8px_28px_-6px_oklch(var(--primary-500)/0.12)] active:translate-y-0 transition-all duration-400 ease-out cursor-pointer p-5 md:p-6 h-full flex flex-col"
            >
              <div className="flex items-center gap-2 mb-4">
                <span className="w-5 h-5 flex items-center justify-center text-primary-500">
                  <i className="ri-fire-line"></i>
                </span>
                <span className="text-xs font-semibold text-primary-600">飙升</span>
              </div>
              <div className="flex-1 flex flex-col items-center justify-center">
                <div className="w-40 h-56 rounded-xl overflow-hidden mb-4">
                  <img
                    src={featuredComic.cover}
                    alt={featuredComic.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500 ease-out"
                    loading="lazy"
                  />
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-1 text-center group-hover:text-primary-500 transition-colors duration-200">
                  {featuredComic.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-2">{featuredComic.author}</p>
                <p className="text-xs text-foreground-400">{featuredComic.updateInfo}</p>
                <div className="flex items-center gap-1 mt-2">
                  <span className="w-4 h-4 flex items-center justify-center text-accent-500">
                    <i className="ri-star-fill text-xs"></i>
                  </span>
                  <span className="text-xs font-medium text-foreground-700">{featuredComic.rating}</span>
                </div>
              </div>
            </Link>
          </ScrollReveal>

          {/* 右侧列表 */}
          <div className="lg:col-span-4 flex flex-col gap-5">
            {risingComics.map((comic, i) => (
              <ScrollReveal key={comic.id} direction="right" delay={150 + i * 100} duration={550}>
                <Link
                  to={`/article/${comic.id}`}
                  className="group flex items-start gap-4 bg-background-50 rounded-2xl border border-background-200/70 hover:border-accent-300 hover:-translate-y-0.5 hover:shadow-[0_4px_20px_-4px_oklch(var(--accent-500)/0.1)] active:translate-y-0 transition-all duration-300 ease-out cursor-pointer p-4 md:p-5"
                >
                  <div className="w-20 h-28 rounded-lg overflow-hidden shrink-0">
                    <img
                      src={comic.cover}
                      alt={comic.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-accent-100 text-accent-700 rounded-full text-xs font-medium">
                        <span className="w-3 h-3 flex items-center justify-center">
                          <i className="ri-flashlight-line text-[10px]"></i>
                        </span>
                        完结
                      </span>
                    </div>
                    <h3 className="font-heading text-base font-bold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 mb-1">
                      {comic.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mb-2">{comic.author}</p>
                    <p className="text-xs text-foreground-400 line-clamp-1">{comic.description}</p>
                    <div className="flex items-center gap-1 mt-2">
                      <span className="w-4 h-4 flex items-center justify-center text-accent-500">
                        <i className="ri-star-fill text-[10px]"></i>
                      </span>
                      <span className="text-xs font-medium text-foreground-700">{comic.rating}</span>
                      <span className="text-xs text-foreground-400 ml-2">{comic.views}阅读</span>
                    </div>
                  </div>
                </Link>
              </ScrollReveal>
            ))}

            {hotList.map((comic, i) => (
              <ScrollReveal key={comic.id} direction="right" delay={350 + i * 100} duration={550}>
                <Link
                  to={`/article/${comic.id}`}
                  className="group flex items-start gap-4 bg-background-50 rounded-2xl border border-background-200/70 hover:border-primary-300 hover:-translate-y-0.5 hover:shadow-[0_4px_20px_-4px_oklch(var(--primary-500)/0.1)] active:translate-y-0 transition-all duration-300 ease-out cursor-pointer p-4 md:p-5"
                >
                  <div className="w-20 h-28 rounded-lg overflow-hidden shrink-0">
                    <img
                      src={comic.cover}
                      alt={comic.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-primary-100 text-primary-700 rounded-full text-xs font-medium">
                        <span className="w-3 h-3 flex items-center justify-center">
                          <i className="ri-fire-line text-[10px]"></i>
                        </span>
                        热门
                      </span>
                    </div>
                    <h3 className="font-heading text-base font-bold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 mb-1">
                      {comic.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mb-2">{comic.author}</p>
                    <p className="text-xs text-foreground-400 line-clamp-1">{comic.description}</p>
                    <div className="flex items-center gap-1 mt-2">
                      <span className="w-4 h-4 flex items-center justify-center text-accent-500">
                        <i className="ri-star-fill text-[10px]"></i>
                      </span>
                      <span className="text-xs font-medium text-foreground-700">{comic.rating}</span>
                      <span className="text-xs text-foreground-400 ml-2">{comic.views}阅读</span>
                    </div>
                  </div>
                </Link>
              </ScrollReveal>
            ))}
          </div>
        </div>

        <ScrollReveal direction="up" delay={200} duration={500} className="mt-10 text-center">
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium text-foreground-700 hover:text-foreground-900 border border-foreground-300 rounded-full hover:border-foreground-500 hover:-translate-y-0.5 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            查看更多热门作品
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </ScrollReveal>
      </div>
    </section>
  )
}